/**
 * Login Route - React Router v7
 *
 * Route: /login/
 * Description: User login page with Gigya authentication
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import {getInitialProps} from './getInitialProps.js'
import Login from './index.js'

// coches.scss / motos.scss set the tenant's variables and import index.scss (tenantImportResolverPlugin)
import './styles/__TENANT__.scss'

/**
 * Loader for Login page
 * Fetches SEO data and target page for redirect after login
 */
export async function loader({context, request}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname
  const search = url.search

  const routeInfo = {
    location: {
      pathname,
      search
    }
  }

  try {
    const initialProps = await getInitialProps({
      routeInfo,
      context
    })

    return {
      ...initialProps,
      __RR7__: true
    }
  } catch (error: unknown) {
    console.error('[RR7] Login loader error:', error)
    throw error
  }
}

/**
 * Component wrapper for RR7
 */
export function Component() {
  const data = useLoaderData()

  return <Login {...data} />
}

Component.displayName = 'LoginRoute'
